import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
//import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { ListErrorsComponent } from './list-errors.component';


@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
  //  HeaderComponent, 
   //   FooterComponent,
    ListErrorsComponent
  ],
  exports: [
    ListErrorsComponent,
  ]
})
export class SharedModule { }
